import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import logo from "../assets/images/brand/logo.png";
import "../styles/not-found.css";

const NotFound = () => {
  return (
    <div className="not-found-page">
      <Helmet>
        <title>Página no encontrada | Cáceres Maquinarias</title>
      </Helmet>

      <div className="not-found-container">
        <div className="not-found-bg-number">404</div>

        <div className="not-found-content">
          <img
            src={logo}
            alt="Cáceres Maquinarias"
            className="not-found-logo"
          />

          <h1 className="not-found-title">Página no encontrada</h1>
          <p className="not-found-subtitle">
            La página que buscás no existe.
            <br />
            Pero podés seguir explorando nuestro catálogo.
          </p>

          <div className="not-found-actions">
            <Link to="/" className="not-found-btn primary">
              Volver al inicio
            </Link>
            <Link to="/productos" className="not-found-btn secondary">
              Ver productos
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
